const styles = {
  tableBorder: {
    borderBottom: "2px solid rgb(223, 225, 230)",
  },
  table: {
    border: "2px solid rgb(223, 225, 230)",
  },
};
export default styles;
